import { Component, OnInit, Output, EventEmitter, Input, signal } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { faAngleLeft, faPlus, faCaretRight, faCalendar } from '@fortawesome/free-solid-svg-icons';
import { NgbActiveModal, NgbDatepickerModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { Site } from '../../../site';
import { User } from '../../../user';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgIf } from '@angular/common';
import { MultiYearAgreementService } from '@app-shared/services/multi-year-agreement.service';
import { AlertService } from '@main/alert.service';


@Component({
  selector: 'app-generate-next-mya-project-modal',
  imports: [ReactiveFormsModule, NgIf, NgbDatepickerModule, FaIconComponent, NgbTimepickerModule],
  templateUrl: './generate-next-mya-project-modal.component.html',
  styleUrl: './generate-next-mya-project-modal.component.css'
})
export class GenerateNextMyaProjectModalComponent implements OnInit {
  // Properties
  nextMyaProjectForm: UntypedFormGroup;
  sites: Site[] = [];
  showAddSiteButton: boolean = false;
  loginDetails: User;
  optionalStagesAreCollapsed: boolean = true;
  amountType: string = 'DOLLAR';
  @Output() okay = new EventEmitter<any>();
  @Input() myaId = signal<string | null>(null);
  @Input() projectName = signal<string | "">("");
  @Input() projectYear = signal<number | null>(null);

  // Font Awesome Properties
  faAngleLeft = faAngleLeft;
  faPlus = faPlus;
  faCaretRight = faCaretRight;
  faCaretDown = faCaretRight
  faCalendar = faCalendar;


  constructor(public modal: NgbActiveModal,
    private multiYearAgreementService: MultiYearAgreementService,
    private alertService: AlertService
  ) { }

  ngOnInit(): void {
    this.loginDetails = JSON.parse(localStorage.getItem('login'));
    this.nextMyaProjectForm = new UntypedFormGroup({
      year: new UntypedFormControl(),
      title: new UntypedFormControl(),
      autoAcceptProposal: new UntypedFormControl(true),
      autoGeneratingInvoice: new UntypedFormControl(true),
      amount: new UntypedFormControl(),
      issueDate: new UntypedFormControl(),
      dueDate: new UntypedFormControl(),
      scheduleSendInvoice: new UntypedFormControl(false),
      sendTime: new UntypedFormControl('09:00'),
    });

    const projectName = this.projectName() || '';
    const yearMatch = projectName.match(/\d{4}/);
    const nextYear = yearMatch ? Number(yearMatch[0]) + 1 : Number(this.projectYear()) + 1;
    this.nextMyaProjectForm.controls.year.setValue(nextYear);
    const nextProjectName = yearMatch && yearMatch[0] ? this.projectName()?.replace(yearMatch[0], nextYear.toString()) : this.projectName();
    this.nextMyaProjectForm.controls.title.setValue(nextProjectName);
  }

  // Add Next MYA Project
  addNextMyaProject(): void {
    const { issueDate, dueDate} = this.nextMyaProjectForm.value;
    const toJSDate = (date: { year: number; month: number; day: number }) =>
      new Date(date.year, date.month - 1, date.day);
    let autoGenerateInvoice = this.nextMyaProjectForm.value.autoGeneratingInvoice;
    let scheduleSendInvoice = this.nextMyaProjectForm.value.scheduleSendInvoice;
    if(!this.nextMyaProjectForm.value.autoAcceptProposal) {
      autoGenerateInvoice = false;
      scheduleSendInvoice = false;
    }

    if(!this.nextMyaProjectForm.value.autoGeneratingInvoice) {
      scheduleSendInvoice = false;
    }
      const payload = {
        myaId: this.myaId(),
        year: this.nextMyaProjectForm.value.year,
        title: this.nextMyaProjectForm.value.title,
        autoAcceptProposal: this.nextMyaProjectForm.value.autoAcceptProposal,
        autoGenerateInvoice: autoGenerateInvoice,
        amount: this.nextMyaProjectForm.value.amount || 0,
        issueDate: dueDate ? toJSDate(issueDate): null,
        dueDate: dueDate ? toJSDate(dueDate): null,
        scheduleSendInvoice: scheduleSendInvoice,
        sendTime: this.nextMyaProjectForm.value.sendTime,
        amountType: this.amountType
      };

      this.nextMyaProjectForm.markAllAsTouched();
      this.nextMyaProjectForm.markAsDirty();
      this.nextMyaProjectForm.updateValueAndValidity();
      this.multiYearAgreementService.addNextMyaProject(payload).subscribe((projectId) => {
        this.alertService.showSuccessAlert('Generated Next MYA Project Successfully');
        this.modal.close();
        this.okay.emit(projectId);
      });
  }

  // Project Form Accessors
  get year() { return this.nextMyaProjectForm.controls.year; }
  get title() { return this.nextMyaProjectForm.controls.title; }
  get autoAcceptProposal() { return this.nextMyaProjectForm.controls.autoAcceptProposal; }
  get autoGeneratingInvoice() { return this.nextMyaProjectForm.controls.autoGeneratingInvoice; }
  get amount() { return this.nextMyaProjectForm.controls.amount; }
  get issueDate() { return this.nextMyaProjectForm.controls.issueDate; }
  get dueDate() { return this.nextMyaProjectForm.controls.dueDate; }
  get scheduleSendInvoice() { return this.nextMyaProjectForm.controls.scheduleSendInvoice; }
  get sendTime() { return this.nextMyaProjectForm.controls.sendTime; }
}
